export const SET_NUDATA_SESSION = 'SET_NUDATA_SESSION';

export const setNudataSession = (nudataSession) => ({
	type: SET_NUDATA_SESSION,
	nudataSession,
});
